module.exports = __webpack_public_path__ + "assets/img/logo2.558456e0.svg";